import {
  type DlsgPolicy,
  type BackupVault,
  type InventoryResource,
  type ListDlsgPoliciesResponse,
  HighFrequencyBackupScheduleFrequency,
  Provider,
  ResourceType,
  ScheduleMode,
} from '@repo/api-gw-sdk';
import type { NextRequest } from 'next/server';

import { getDemoSettings } from '@/contexts/environment';

import { inventoryData } from '../../inventory/inventoryData';
import { vaultsDAL } from '../../vaults/vaultsDAL';

export const generateDlsgPolicy = (
  item: InventoryResource,
  vault?: BackupVault
): DlsgPolicy => {
  return {
    id: '21c1d926-ce0c-1234-bb51-d6fbf7c46588',
    name: 'Gateway Policy',
    resourceInclusion: item ? [item.providerResourceId] : [],
    scheduleMode: ScheduleMode.SCHEDULE_MODE_BASIC,
    policyPlan: {
      resourceTypes: [ResourceType.AwsS3],
      backupSchedule: {
        vaultId: vault?.id || item.vaults[0]?.id,
        backupRetentionDays: 5,
        scheduleConfig: {
          frequency:
            HighFrequencyBackupScheduleFrequency.HIGH_FREQUENCY_BACKUP_SCHEDULE_DAILY,
          dailyConfig: {
            timeOfDay: {
              hour: 0,
              minute: 0,
            },
          },
        },
      },
      dlsgConfig: [
        {
          pathPrefixes: [
            '/returns-and-refunds/logs/documents/',
            '/returns-and-refunds/logs/assets/',
            '/returns-and-refunds/logs/prod/',
            '/ml/models/v/',
          ],
          isTruncateData: true,
          migrationDelayHours: 5 * 24,
        },
        {
          pathPrefixes: ['/returns-and-refunds/claims/', '/ml/models/assets/'],
          isTruncateData: false,
          migrationDelayHours: 10 * 24,
        },
      ],
    },
  };
};

export async function POST(req: NextRequest) {
  const demoSettings = getDemoSettings(req);
  const vaults = vaultsDAL.list(demoSettings);
  const inventory = inventoryData(demoSettings);
  const item = inventory.find((x) => x.dlsgPolicy?.id);
  const vault = vaults.find(
    (x) => x.vaultAttributes.cloudProvider === Provider.Aws
  );

  if (!vault || !item) {
    return Response.json({
      dlsgPolicies: [],
      totalCount: 0,
    } satisfies ListDlsgPoliciesResponse);
  }

  return Response.json({
    dlsgPolicies: [generateDlsgPolicy(item, vault)],
    totalCount: 1,
  } satisfies ListDlsgPoliciesResponse);
}
